// @flow
import React, { Component, Fragment } from "react";

import type { ErrorsType } from "../../types/UserFormType";
import { StyledSelect, CancelButton, SubmitButton } from "imagus-components";
import CompanyInfo from "../../components/companies/CompanyInfo";
import { ErrosDisplay, setErrorMsg } from "../../containers/ErrosDisplay";
import { buildCompanyInfoJson } from "../../components/companies/CompileCompanytoJson";
import {
  GraphqlLineBreak,
  utf8OutRangeFilter
} from "../../../global/functions/MultilLineStrings";
import ProjectBasicFields from "./ProjectBasicFields";

import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Tooltip from "@material-ui/core/Tooltip";
import ErrorIcon from "@material-ui/icons/Error";

type EditProjectFormPropsType = {
  onClose: Function,
  openSnackbar?: Function,
  initialForm?: { [key: string]: * },
  ResellerCompanyList: Array<*>,
  IsDisabledEndUserChange: boolean,
  updateEndUserList: Function,
  updateProject: Function
};

type EditProjectFormFormStatesType = {
  errors: ErrorsType,
  loading: boolean,
  project_name: string,
  camera_count: string,
  face_count: string,
  expiry_date: Date | null,
  notes: string,
  reseller_id: string,
  reseller: { [key: string]: string } | null,
  end_user_list: Array<*> | null,
  enduser_id: string,
  end_user: { [key: string]: string } | null,
  country: string,
  state: string,
  other_state: string,
  postcode: string,
  city: string,
  suburb: string,
  address: string
};

const initialform: EditProjectFormFormStatesType = {
  errors: {},
  loading: false,
  project_name: "",
  camera_count: "",
  face_count: "",
  expiry_date: null,
  notes: "",
  reseller_id: "",
  reseller: null,
  end_user_list: null,
  enduser_id: "",
  end_user: null,
  country: "Australia",
  state: "",
  other_state: "",
  postcode: "",
  city: "",
  suburb: "",
  address: ""
};

class EditProjectForm extends Component<
  EditProjectFormPropsType,
  EditProjectFormFormStatesType
> {
  constructor(props: EditProjectFormPropsType) {
    super(props);
    this.submit = this.submit.bind(this);
    this.state = initialform;
  }

  componentDidMount() {
    this.setState({ ...initialform, ...this.props.initialForm });
  }

  handleTextChange = (e: SyntheticInputEvent<*>): * => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value });
  };

  syncDateChange = (name: string, date: Date): * => {
    this.setState({ [name]: date });
  };

  handleTypeChange = (e: SyntheticInputEvent<*>): * => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value }, (): * => {
      if (name === "reseller_id") {
        this.checkCompany("reseller");

        const values = this.props.updateEndUserList(value);
        this.setState({
          reseller: values[0],
          end_user_list: values[1],
          enduser_id: "",
          end_user: null
        });
      }
      if (name === "enduser_id") {
        this.checkCompany("enduser");

        const children = this.state.reseller.children.edges;
        let index = children.findIndex((x) => x.node.id === value);
        this.setState({ end_user: children[index].node });
      }
    });
  };

  checkCompany = (type: "reseller" | "enduser"): * => {
    const name = type === "reseller" ? "reseller_id" : "enduser_id";
    if (this.state[name] === "") {
      this.setState({
        errors: setErrorMsg(
          this.state.errors,
          type,
          "Please Select a " + type + " company."
        )
      });
    } else {
      this.setState({ errors: setErrorMsg(this.state.errors, type, "", true) });
    }
  };

  submit = async (e: Event): * => {
    e.preventDefault();
    e.stopPropagation();
    this.checkCompany("reseller");
    this.checkCompany("enduser");

    if (Object.keys(this.state.errors).length === 0) {
      this.setState((): * => ({ loading: true }));
      const generalDetails = [
        this.state.project_name,
        this.state.expiry_date,
        GraphqlLineBreak(utf8OutRangeFilter(this.state.notes)),
        this.state.camera_count,
        this.state.face_count,
        this.state.address,
        this.state.suburb,
        this.state.city,
        this.state.state === "Other"
          ? this.state.other_state
          : this.state.state,
        this.state.country,
        this.state.postcode,
        this.state.reseller_id,
        this.state.enduser_id,
        this.submitDone,
        this.submitFail
      ];

      this.props.updateProject(...generalDetails);
    }
  };

  submitDone = () => {
    this.props.onClose();
    this.props.openSnackbar && this.props.openSnackbar(7);
  };

  submitFail = (errors: ErrorsType) => {
    this.setState({ errors: errors, loading: false });
  };

  render(): React$Element<*> {
    const errors = this.state.errors;
    const loading = this.state.loading;
    const IsDisabledEndUserChange = this.props.IsDisabledEndUserChange;

    return (
      <form
        onSubmit={(!loading && this.submit) || undefined}
        className="app-wrapper"
      >
        <div className="app-panel">
          <div className="app-panel-content">
            <Grid container spacing={8}>
              <ProjectBasicFields
                project_name={this.state.project_name}
                expiry_date={this.state.expiry_date}
                face_count={this.state.face_count}
                camera_count={this.state.camera_count}
                address={this.state.address}
                suburb={this.state.suburb}
                postcode={this.state.postcode}
                city={this.state.city}
                state={this.state.state}
                other_state={this.state.other_state}
                country={this.state.country}
                notes={this.state.notes}
                handleTextChange={this.handleTextChange}
                handleSelectChange={this.handleTypeChange}
                syncDateChange={this.syncDateChange}
              />

              <Fragment>
                <Grid item xs={11} md={6}>
                  <StyledSelect
                    value={this.state.reseller_id}
                    onChange={this.handleTypeChange}
                    name="reseller_id"
                    label="Select Reseller Company"
                    isRequired={true}
                    menus={this.props.ResellerCompanyList}
                    isInvalid={errors.reseller !== undefined}
                    isStyled
                    isDisabled={IsDisabledEndUserChange}
                  />
                </Grid>
                <Grid item xs={1} style={{ marginTop: "40px" }}>
                  {IsDisabledEndUserChange && (
                    <Tooltip title="This project has linked licence">
                      <ErrorIcon
                        className="grey-icon right-margin-10"
                        style={{ verticalAlign: "text-bottom" }}
                      />
                    </Tooltip>
                  )}
                </Grid>
                {this.state.reseller && (
                  <Grid item xs={12}>
                    <Paper style={{ paddingTop: "5px" }}>
                      <Typography variant="h5" className="form-text">
                        Reseller Company
                      </Typography>
                      <CompanyInfo
                        company={buildCompanyInfoJson(this.state.reseller)}
                      />
                    </Paper>
                  </Grid>
                )}
                {this.state.end_user_list && (
                  <Fragment>
                    <Grid item xs={11} md={6}>
                      <StyledSelect
                        value={this.state.enduser_id}
                        onChange={this.handleTypeChange}
                        name="enduser_id"
                        label="Select End User Company"
                        isRequired={true}
                        menus={this.state.end_user_list}
                        isInvalid={errors.enduser !== undefined}
                        isStyled
                        isDisabled={IsDisabledEndUserChange}
                      />
                    </Grid>
                    <Grid item xs={1} style={{ marginTop: "40px" }}>
                      {IsDisabledEndUserChange && (
                        <Tooltip title="This project has linked licence">
                          <ErrorIcon
                            className="grey-icon right-margin-10"
                            style={{ verticalAlign: "text-bottom" }}
                          />
                        </Tooltip>
                      )}
                    </Grid>
                  </Fragment>
                )}
                {this.state.end_user && (
                  <Grid item xs={12}>
                    <Paper style={{ paddingTop: "5px" }}>
                      <Typography variant="h5" className="form-text">
                        End User Company
                      </Typography>
                      <CompanyInfo
                        company={buildCompanyInfoJson(this.state.end_user)}
                      />
                    </Paper>
                  </Grid>
                )}
              </Fragment>
              <Grid item xs={12}>
                <ErrosDisplay errors={errors} form="create project" />
              </Grid>
              <Grid item xs={12}>
                <div className="form-right-btn-block">
                  <CancelButton onClick={this.props.onClose} />
                  <SubmitButton
                    loading={loading}
                    disabled={Object.keys(errors).length > 0}
                  />
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
      </form>
    );
  }
}

export default EditProjectForm;
